<script setup>
const { t } = useI18n()
</script>

<template>
  <div
    class="closed-container"
  >
    <div class="closed-event">
      {{ t('Closed') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
    .closed-container {
  @apply flex flex-1 justify-center items-center min-h-100px opactiy-80 b-rounded-2;
  background: repeating-linear-gradient(
    -45deg,
    var(--colors-surface-600),
    var(--colors-surface-600) 3px,
    var(--colors-surface-100) 3px,
    var(--colors-surface-100) 5.5px
  );
}

.closed-event {
  @apply text-sm bg-surface-700 rounded p-block-1 p-inline-2 text-text-600 text-center;
}
</style>

<i18n>
{
  "en-us": {
    "Closed": "Closed"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Closed": "Geschlossen"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Closed": "Cerrado"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Closed": "Clôturé(e)"
}
</i18n>
